/*
 * Paginazione mista della griglia collezione.
 * Pagina dispari mostrata -> la successiva si carica da sola quando si arriva in fondo.
 * Pagina pari mostrata    -> compare il pulsante "Vedi altro".
 * La griglia viene ridisegnata dai filtri (facets.js): un MutationObserver
 * inizializza ogni nuovo contenitore [data-hybrid-pagination].
 */
(function () {
  function pageUrl(baseUrl, page) {
    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('page', page);
    return url.toString();
  }

  function init(root) {
    if (root.dataset.hybridReady) return;
    root.dataset.hybridReady = 'true';

    let total = parseInt(root.dataset.totalPages, 10);
    let nextUrl = root.dataset.nextUrl;
    let page = parseInt(root.dataset.currentPage, 10);
    const sentinel = root.querySelector('[data-hybrid-sentinel]');
    const buttonWrapper = root.querySelector('[data-hybrid-button-wrapper]');
    const button = root.querySelector('[data-hybrid-button]');
    const grid = root.closest('.collection, [id^="ProductGridContainer"], .shopify-section')?.querySelector('.load-more-grid')
      || document.querySelector('.load-more-grid');
    let loading = false;
    let failed = false;
    let observer = null;

    if (!grid || !nextUrl || !Number.isFinite(page) || !Number.isFinite(total) || page >= total) {
      root.remove();
      return;
    }

    function stopObserving() {
      if (observer) observer.disconnect();
      observer = null;
      sentinel.hidden = true;
    }

    function showNextTrigger() {
      if (!root.isConnected || !nextUrl || page >= total) {
        stopObserving();
        button.disabled = true;
        root.remove();
        return;
      }
      if (page % 2 === 1 && !failed) {
        buttonWrapper.hidden = true;
        sentinel.hidden = false;
        observer = new IntersectionObserver((entries) => {
          if (!root.isConnected) {
            stopObserving();
            return;
          }
          if (entries.some((entry) => entry.isIntersecting)) load();
        }, { rootMargin: '300px 0px' });
        observer.observe(sentinel);
      } else {
        stopObserving();
        buttonWrapper.hidden = false;
      }
    }

    function load() {
      if (loading || !root.isConnected || !nextUrl || page >= total) return;
      loading = true;
      stopObserving();
      button.setAttribute('disabled', '');
      button.classList.add('loading');

      fetch(pageUrl(nextUrl, page + 1), { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('Unable to load collection page');
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextGrid = doc.querySelector('.load-more-grid');
          if (!root.isConnected || !grid.isConnected) return;
          if (!nextGrid) throw new Error('Collection grid missing');
          const nextPagination = doc.querySelector('[data-hybrid-pagination]');
          const returnedPage = Number(nextPagination?.dataset.currentPage);
          if (!nextGrid.children.length || (returnedPage && returnedPage <= page)) {
            nextUrl = '';
            return;
          }
          Array.from(nextGrid.children).forEach((item) => grid.appendChild(item));
          page += 1;
          nextUrl = nextPagination?.dataset.nextUrl || '';
          const returnedTotal = Number(nextPagination?.dataset.totalPages);
          if (returnedTotal > 0) total = returnedTotal;
          root.dataset.currentPage = page;
          root.dataset.nextUrl = nextUrl;
          root.dataset.totalPages = total;
          if (typeof colorSwatches === 'function') colorSwatches();
        })
        .then(() => {
          failed = false;
        })
        .catch(() => {
          // Errore di rete: si mostra il pulsante per riprovare la stessa pagina.
          failed = true;
        })
        .finally(() => {
          loading = false;
          button.removeAttribute('disabled');
          button.classList.remove('loading');
          showNextTrigger();
        });
    }

    button.addEventListener('click', load);
    showNextTrigger();
  }

  function initAll() {
    document.querySelectorAll('[data-hybrid-pagination]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
})();
